import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PostPollDraft } from '../../utils/post-poll-draft';

/** The option boxes + duration picker shown under a composer while "Poll" is switched on. */
@Component({
  selector: 'app-social-poll-composer',
  templateUrl: './social-poll-composer.component.html',
  styleUrls: ['./social-poll-composer.component.scss'],
  standalone: false,
  // Angular 22 defaults to OnPush; this one reads an object its parent changes in place
  // (the `draft` input keeps the same reference), so it has to be checked on every pass.
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class SocialPollComposerComponent {
  @Input({ required: true }) draft!: PostPollDraft;

  readonly durations = PostPollDraft.DURATIONS;
  readonly maxOptions = PostPollDraft.MAX_OPTIONS;
  readonly maxLength = PostPollDraft.OPTION_MAX_LENGTH;

  onDuration(value: string): void {
    this.draft.hours = value ? Number(value) : null;
  }
}
